export default __webpack_public_path__ + "static/media/cert-market-cpttm.46af4ab5.jpg";